var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedin1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.43915C0 0.648115 0.661687 0.00646973 1.47796 0.00646973H18.522C19.3383 0.00646973 20 0.648115 20 1.43915V18.5738C20 19.3651 19.3383 20.0065 18.522 20.0065H1.47796C0.661687 20.0065 0 19.3651 0 18.5738V1.43915Z",
    fill: "#0A63BC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.47195 16.6732V8.239H3.50867V16.6732H6.47195ZM4.99029 7.08745C6.02365 7.08745 6.66683 6.4398 6.66683 5.63043C6.64757 4.80284 6.02365 4.17316 5.0099 4.17316C3.99625 4.17316 3.3335 4.80284 3.3335 5.63043C3.3335 6.4398 3.97654 7.08745 4.97098 7.08745H4.99029Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.3335 16.6732H11.0635V12.1262C11.0635 11.8828 11.0812 11.6397 11.1533 11.4658C11.3507 10.9795 11.7999 10.476 12.554 10.476C13.5419 10.476 13.9371 11.2227 13.9371 12.3172V16.6732H16.6668V12.0045C16.6668 9.50356 15.32 8.33982 13.5239 8.33982C12.0511 8.33982 11.4045 9.15588 11.0453 9.71173H11.0636V8.53089H8.33357C8.3694 9.2949 8.3335 16.6732 8.3335 16.6732Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin1);
export default __webpack_public_path__ + "static/media/linkedin_1.dfbf62f4800ad5a1a358280ee394d14b.svg";
export { ForwardRef as ReactComponent };